import React from "react"
import {Table} from "antd";
import _ from "underscore";
import IField from "../../../../../model/interface/dataStorage/IField";
import {ISourcePreviewProps} from "../SourcePreview";
import {ColumnsType} from "antd/es/table";

interface IStateSourceMapping {

}

class SourcePreviewTable extends React.Component<ISourcePreviewProps, IStateSourceMapping> {

    constructor(props: ISourcePreviewProps) {
        super(props);
        this.state = {}
    }

    getFields(className: string): IField[] {
        try {
            return this.props.findServiceByClassName(className).getFields()
        } catch (e){
            return []
        }
    }

    getField = (className: string, name?: string) => {
        return this.getFields(className).find(field => field.name === name)
    }

    buildColumns = () => {
        const columns: ColumnsType<any> = []
        const {type, mapping} = this.props.resource
        const {data} = this.props
        if (data.length > 0) {
            Object.entries(data[0]).forEach(([column]) => {
                const field = this.getField(type, column.split('.')[0]);
                const currentMapping = _.findWhere(mapping, {field: column})
                columns.push({
                    title: (
                        field?.label || currentMapping?.field || column
                    ),
                    ellipsis: true,
                    width: 140,
                    render: (title) => title[column]
                })
            })
        }
        return columns
    }

    render() {
        const {data} = this.props

        return (
            <div className={'w-100  overflow-auto'}>
                <Table
                    rowKey={'index'}
                    columns={this.buildColumns()}
                    dataSource={data}
                    pagination={{hideOnSinglePage: true}}
                />
            </div>
        )
    }
}

export default SourcePreviewTable